var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.loading)?_c('div',{staticClass:"page-spin-action ivu-spin ivu-spin-large ivu-spin-fix"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ivu-spin-main"},[_c('span',{staticClass:"ivu-spin-dot"}),_c('div',{staticClass:"ivu-spin-text"})])
}]

export { render, staticRenderFns }